import { FormProvider } from 'react-hook-form'

import { Stepper } from '../../../../../../../../components/Stepper'
import { Step } from '../../../../../../../../components/Stepper/Step'
import { BankStepForm } from '../../CommonSteps/BankStepForm'
import { useNaturalStepperContainer } from './useNaturalStepperContainer'
import { NaturalStepForm } from './NaturalStepForm'
import { type ExpertDomain } from '../../../../../../../../types/domain/expert-domain'

type NaturalStepperContainerProps = {
  expert?: ExpertDomain
}

export const NaturalStepperContainer = ({
  expert,
}: NaturalStepperContainerProps) => {
  const {
    form,
    currentStep,
    isExpertSubmitting,
    setCurrentStep,
    handleCancel,
    handleSubmit,
  } = useNaturalStepperContainer(expert)

  return (
    <FormProvider {...form}>
      <Stepper currentStep={currentStep}>
        <Step index={0}>
          <NaturalStepForm
            isSubmitting={isExpertSubmitting}
            onCancel={handleCancel}
            onSubmit={() => setCurrentStep(1)}
          />
        </Step>

        <Step index={1}>
          <BankStepForm
            isSubmitting={isExpertSubmitting}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
          />
        </Step>
      </Stepper>
    </FormProvider>
  )
}
